import React, { useState, createContext, useContext } from 'react';
import { translations, Lang } from './translations';
interface LanguageContextType {
  currentLang: Lang;
  setLanguage: (lang: Lang) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [currentLang, setCurrentLang] = useState<Lang>('en');
  const setLanguage = (lang: Lang) => {
    setCurrentLang(lang);
  };
  const t = (key: string): string => {
    if (!translations[key]) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
    return translations[key][currentLang] || translations[key]['en'];
  };
  return <LanguageContext.Provider value={{
    currentLang,
    setLanguage,
    t
  }} data-id="element-183">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}